import { useTranslation } from 'react-i18next'
import { lotLabel } from './foundStockRows'

// The one place a lot is rendered. The queue, the awaiting table and the detail drawer all name the
// same lot, so they cannot be allowed to drift; the branching itself lives in lotLabel, unit-tested.
export const LotCell = ({ row }) => {
  const { i18n } = useTranslation()
  const { code, expires, fallback } = lotLabel(row, i18n)
  return (
    <div>
      <div className={fallback ? 'text-gray-500' : undefined}>{code}</div>
      {expires && <div className="text-xs text-gray-500">{i18n.t('found_stock.queue.lot_expires', { date: expires })}</div>}
    </div>
  )
}
